// O campo `active` chega do MySQL como tinyint (0/1), mas registros legados podem
// não trazer o campo (undefined/null). Regra do contrato (MOB-12):
// - inativo quando o valor está presente e é 0, "0" ou false;
// - ativo em qualquer outro caso — inclusive undefined/null (registro legado sem o campo).
// Cuidado: NÃO usar `value !== false` — `0 !== false` é `true` e esconderia um inativo.
export default function isUserActive(value) {
	return !(value === 0 || value === "0" || value === false);
}
